import React, { useState } from "react";

import Modal from "../../../components/Reusable/Modal";
import { Button } from "../../../components/Reusable/Button";
import { FAQModalProps } from "./types";

const FAQModal: React.FC<FAQModalProps> = ({ isOpen, onClose, onCreate }) => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  const handleCreate = () => {
    if (question.trim() && answer.trim()) {
      onCreate(question, answer);
      setQuestion("");
      setAnswer("");
      onClose();
    }
  };
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white dark:bg-[#1E1E1E] rounded-lg p-6 w-full max-w-md shadow-2xl"
        style={{
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}
        onClick={handleModalClick}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold dark:text-white">Add New FAQ</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white text-2xl"
          >
            &times;
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <input
              type="text"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              className="w-full p-2 border border-gray-300 dark:border-[#FFFFFF1A] rounded dark:bg-[#2D2D2D] text-[#98A2B3] dark:text-white"
              placeholder="Question"
            />
          </div>

          <div>
            <textarea
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              className="w-full p-2 border border-gray-300 dark:border-[#FFFFFF1A] rounded h-24 dark:bg-[#2D2D2D] dark:text-white"
              placeholder="Answer"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 dark:border-[#FFFFFF1A] rounded-md text-sm font-medium dark:text-white"
          >
            Cancel
          </button>
          <Button
            onClick={handleCreate}
            type="submit"
            bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
            textColor="text-white"
            borderRadius="rounded-lg"
            className="w-[126px] h-10"
          >
            Create FAQ
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FAQModal;
